import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Error from "../../assets/DeleteIcon.svg";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";

export const DeleteModal = ({ DeleteFuc, Card_Id, CardNumber, ...props }) => {
  const DeleteHandler = () => {
    DeleteFuc(Card_Id);
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="popup-modal"
    >
      <Modal.Header></Modal.Header>
      <Modal.Body className="text-center mb-5 deleteCardModal">
        <Image loading="lazy" src={Error} className="deleteImg" />
        <p className="py-3 delete-text">Are you sure you want to delete this card?</p>
        <p className="py-3 delete-text">
          {"**** **** ****" + " " + CardNumber}
        </p>
        <div className="text-center small-btns d-flex">
          <Link onClick={props.onHide}>
            <p className="view">No</p>
          </Link>
          <Button
            variant="primary"
            onClick={DeleteHandler}
            className="green-btn mt-3"
          >
            Yes
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
